import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { HttpService } from '../../services/http.service';

@Component({
  selector: 'app-extract',
  templateUrl: './extract.component.html',
  styleUrls: ['./extract.component.scss']
})
export class ExtractComponent implements OnInit {

  ids = '';
  startId = '';
  lastId = '';
  isConfirm = false;
  isCompleted = false;
  isDownload = false;
  checkIds = false;
  checkStartId = false;
  checkLastId = false;
  messageIds = '';
  messageStartId = '';
  messageLastId = '';
  isData = false;
  csvLink = '';
  csvName = '';
  audioLink = '';
  audioName = '';
  imageLink = '';
  imageName = '';
  txtConfirm = '';
  txtCompleted = '';
  dt = {};
  complete = true;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private httpService: HttpService
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (!sessionStorage.getItem('user-info')) {
        this.router.navigateByUrl('/login');
      }
      let userInfo, refreshToken;
      userInfo = JSON.parse(sessionStorage.getItem('user-info'));
      refreshToken = userInfo.refresh_token;
      this.httpService.getNewAccessToken(refreshToken)
        .subscribe((data) => {
          if (data.err_code === 0) {
            userInfo.access_token = data.data.access_token;
            sessionStorage.setItem('user-info', JSON.stringify(userInfo));
          } else {
            sessionStorage.removeItem('user-info');
            this.router.navigateByUrl('/login');
          }
        });
    }
  }

  changeExtract() {
    let valueCheck;
    valueCheck = (<HTMLInputElement>document.querySelector('input[name="extract"]:checked')).value;
    if (valueCheck === '0') {
      (<HTMLTextAreaElement>document.getElementById('ids')).removeAttribute('disabled');
      (<HTMLInputElement>document.getElementById('startid')).setAttribute('disabled', 'disabled');
      (<HTMLInputElement>document.getElementById('lastid')).setAttribute('disabled', 'disabled');
    } else if (valueCheck === '1') {
      (<HTMLTextAreaElement>document.getElementById('ids')).setAttribute('disabled', 'disabled');
      (<HTMLInputElement>document.getElementById('startid')).removeAttribute('disabled');
      (<HTMLInputElement>document.getElementById('lastid')).removeAttribute('disabled');
    } else {
      (<HTMLTextAreaElement>document.getElementById('ids')).setAttribute('disabled', 'disabled');
      (<HTMLInputElement>document.getElementById('startid')).setAttribute('disabled', 'disabled');
      (<HTMLInputElement>document.getElementById('lastid')).setAttribute('disabled', 'disabled');
    }
    (<HTMLTextAreaElement>document.getElementById('ids')).value = '';
    (<HTMLInputElement>document.getElementById('startid')).value = '';
    (<HTMLInputElement>document.getElementById('lastid')).value = '';
  }

  signOut() {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.removeItem('user-info');
    }
    this.router.navigateByUrl('/login');
  }

  handle(v) {
    this.isData = true;
    if (isPlatformBrowser(this.platformId)) {
      let valueCheck;
      const that = this;
      const accessToken = JSON.parse(sessionStorage.getItem('user-info')).access_token;
      this.ids = (<HTMLTextAreaElement>document.getElementById('ids')).value.trim();
      this.startId = (<HTMLInputElement>document.getElementById('startid')).value;
      this.lastId = (<HTMLInputElement>document.getElementById('lastid')).value;
      valueCheck = (<HTMLInputElement>document.querySelector('input[name="extract"]:checked')).value;
      if (valueCheck === '0') {
        if (this.ids === '') {
          this.messageIds = 'Specific datasets cannot blank.';
          this.checkIds = true;
          setTimeout(function () {
            that.checkIds = false;
          }, 3000);
        } else {
          this.dt = {
            access_token: accessToken,
            ids: [this.ids],
            start_id: '0',
            end_id: '0'
          };
          if (v === 'extract') {
            this.complete = false;
            this.httpService.extractFile(this.dt)
              .subscribe((data) => {
                if (data.err_code !== 0) {
                  this.messageIds = 'Please input a valid value.';
                  this.checkIds = true;
                  this.complete = true;
                  setTimeout(function () {
                    that.checkIds = false;
                  }, 3000);
                } else {
                  this.csvLink = data.data.data.file_url;
                  let name;
                  name = this.csvLink.split('/');
                  this.csvName = name[name.length - 1];
                  this.audioLink = data.data.data.audios_url;
                  let audio;
                  audio = this.audioLink.split('/');
                  this.audioName = audio[audio.length - 1];
                  this.imageLink = data.data.data.images_url;
                  let image;
                  image = this.imageLink.split('/');
                  this.imageName = image[image.length - 1];
                  this.isDownload = true;
                  this.complete = true;
                }
              });
          } else {
            this.isConfirm = true;
            this.txtConfirm = 'Are you sure you want to delete dataset ' + this.ids + '?';
          }
        }
      } else if (valueCheck === '1') {
        if (this.startId === '') {
          this.messageStartId = 'Start ID cannot blank.';
          this.checkStartId = true;
          setTimeout(function () {
            that.checkStartId = false;
          }, 3000);
        }
        if (this.lastId === '' || this.lastId === '0') {
          if (this.lastId === '') {
            this.messageLastId = 'Last ID cannot blank.';
            this.checkLastId = true;
            setTimeout(function () {
              that.checkLastId = false;
            }, 3000);
          }
          if (this.lastId === '0') {
            this.messageLastId = 'Last ID cannot start from value 0.';
            this.checkLastId = true;
            setTimeout(function () {
              that.checkLastId = false;
            }, 3000);
          }
        } else {
          if (parseInt(this.lastId, 0) < parseInt(this.startId, 0)) {
            this.messageLastId = 'Last ID cannot be less than Start ID.';
            this.checkLastId = true;
            setTimeout(function () {
              that.checkLastId = false;
            }, 3000);
          }
        }
        if (this.checkStartId === false && this.checkLastId === false) {
          this.dt = {
            access_token: accessToken,
            ids: [],
            start_id: this.startId,
            end_id: this.lastId
          };
          if (v === 'extract') {
            this.complete = false;
            this.httpService.extractFile(this.dt)
              .subscribe((data) => {
                this.csvLink = data.data.data.file_url;
                let name;
                name = this.csvLink.split('/');
                this.csvName = name[name.length - 1];
                this.audioLink = data.data.data.audios_url;
                let audio;
                audio = this.audioLink.split('/');
                this.audioName = audio[audio.length - 1];
                this.imageLink = data.data.data.images_url;
                let image;
                image = this.imageLink.split('/');
                this.imageName = image[image.length - 1];
                this.isDownload = true;
                this.complete = true;
              });
          } else {
            this.isConfirm = true;
            this.txtConfirm = 'Are you sure you want to delete dataset from ' + this.startId + ' to ' + this.lastId + '?';
          }
        }
      }
    }
  }

  exCustom(type) {
    this.isData = false;
    if (isPlatformBrowser(this.platformId)) {
      const accessToken = JSON.parse(sessionStorage.getItem('user-info')).access_token;
      this.httpService.extractCustom(accessToken, type)
        .subscribe((data) => {
          this.complete = true;
          this.csvLink = data.data.file_url;
          let name;
          name = this.csvLink.split('/');
          this.csvName = name[name.length - 1];
          this.isDownload = true;
        });
    }
  }

  isNumberKey(event) {
    let charCode;
    charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    } else {
      return true;
    }
  }

  yesDelete() {
    this.httpService.deleteData(this.dt)
      .subscribe(() => {
        this.isConfirm = false;
        this.isCompleted = true;
        if (this.ids === '') {
          this.txtCompleted = 'Successfully deleted dataset ' + this.startId + ' to ' + this.lastId + '.';
        } else {
          this.txtCompleted = 'Successfully deleted dataset ' + this.ids + '.';
        }
      });
  }

  noDelete() {
    this.isConfirm = false;
  }

  okAction() {
    this.isCompleted = false;
    (<HTMLTextAreaElement>document.getElementById('ids')).value = '';
    (<HTMLInputElement>document.getElementById('startid')).value = '';
    (<HTMLInputElement>document.getElementById('lastid')).value = '';
  }

  closePopup() {
    this.isDownload = false;
    (<HTMLTextAreaElement>document.getElementById('ids')).value = '';
    (<HTMLInputElement>document.getElementById('startid')).value = '';
    (<HTMLInputElement>document.getElementById('lastid')).value = '';
  }

}
